import React, {Component, PropTypes} from 'react'

import {Icon} from 'antd'
import ImagePreview from '../common/ImagePreview'
import {API_ROOT} from '../../config'

class AttachmentList extends Component {
  constructor (props) {
    super(props)
    this.state = {
      previewVisible: false,
      previewUrl: ''
    }
  }
  previewHandle = (url, fileType = '') => {
    const supportImgTypes = ['JPEG', 'GIF', 'PNG', 'APNG', 'SVG']
    if (!fileType) {
      let index = url.lastIndexOf('.')
      fileType = url.slice(index + 1).toLocaleUpperCase()
    }
    if (supportImgTypes.includes(fileType)) {
      this.setState({previewUrl: url, previewVisible: true})
    } else {
      window.open(url)
    }
  }
	render () {
    const {attachment} = this.props
		return (typeof attachment.length === 'undefined' || attachment.length === 0) ? null : (
      <div className="attachment-w">
        <div className="common-t">附件信息：</div>
        <div className="attachment-list-w">
          {
            attachment.map(item => {
              return (
                <p className="file" key={item.id} >
                  <span onClick={() => this.previewHandle(`${item.url}`)}><Icon type="paper-clip" /> {item.name}</span> 
                </p>
              )
            })
          }
          <ImagePreview visible={this.state.previewVisible} previewUrl={this.state.previewUrl} onClose={() => {this.setState({previewVisible: false})}}/>
        </div>
      </div>
		)
	}
}


export default AttachmentList


// WEBPACK FOOTER //
// ./src/components/workflow/attachmentList.js